// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__0b0wO","ellipsis":"styles_ellipsis__lxlSv","text2AndMoreLines":"styles_text2AndMoreLines__ZYpkn","tooltipTrigger":"styles_tooltipTrigger__Ji56z"};